import { schema } from 'normalizr';
import userSchema from './user';
import orgSchema from './org';
import { SCHEMA_TYPE_PROJECTS } from '../constants/schemaTypes';

const projectSchema = new schema.Entity(SCHEMA_TYPE_PROJECTS, {
  owner: userSchema,
  org: orgSchema,
});

export default projectSchema;
